"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var domTraverse_1 = require("./domTraverse");
var domMutations_1 = require("./domMutations");
exports.IGNORE_TAGS = [
    'SCRIPT', 'STYLE', 'SELECT', 'OPTION', 'BUTTON', 'OBJECT', 'APPLET', 'VIDEO', 'AUDIO', 'CANVAS', 'EMBED',
    'PARAM', 'METER', 'PROGRESS'
];
exports.IGNORE_TAG_CLASS = 'atomHL';
exports.IGNORE_TAG_ALL_CHILDREN_CLASS = 'atomHLFull';
var atomTags = [];
var NODE_TYPE;
(function (NODE_TYPE) {
    NODE_TYPE[NODE_TYPE["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
    NODE_TYPE[NODE_TYPE["TEXT_NODE"] = 3] = "TEXT_NODE";
})(NODE_TYPE = exports.NODE_TYPE || (exports.NODE_TYPE = {}));
var NodeActionType;
(function (NodeActionType) {
    NodeActionType[NodeActionType["WHOLE"] = 0] = "WHOLE";
    NodeActionType[NodeActionType["BETWEEN"] = 1] = "BETWEEN";
    NodeActionType[NodeActionType["TO"] = 2] = "TO";
    NodeActionType[NodeActionType["FROM"] = 3] = "FROM";
})(NodeActionType = exports.NodeActionType || (exports.NodeActionType = {}));
function isTextSelectionChunk(node, ignoreTags) {
    if (node.nodeType === NODE_TYPE.TEXT_NODE && node.parentNode) {
        var parentElement = node.parentNode;
        // If parent contain IGNORE_TAG_ALL_CHILDREN_CLASS we skip this node
        if (parentElement.className.indexOf(exports.IGNORE_TAG_ALL_CHILDREN_CLASS) > 0) {
            atomTags.push(parentElement);
            return false;
        }
        var isNodeInAtomTags = atomTags.some(function (atomTag) { return atomTag.contains(node) || contains(atomTag, node); });
        if (atomTags.length > 0 && isNodeInAtomTags ||
            ignoreTags.indexOf(parentElement.nodeName.toUpperCase()) > 0) {
            return false;
        }
        // and the parent is not one of ignored elements
        // and if parent is not contains 'atomHL' class
        return ignoreTags.indexOf(parentElement.nodeName.toUpperCase()) < 0 &&
            (!parentElement.className || parentElement.className.indexOf(exports.IGNORE_TAG_CLASS) < 0);
    }
    else {
        return false;
    }
}
exports.isTextSelectionChunk = isTextSelectionChunk;
// workaround for IE
// https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
function contains(parent, child) {
    var iterableNode = child.parentNode;
    while (iterableNode) {
        if (iterableNode === parent) {
            return true;
        }
        iterableNode = iterableNode.parentNode;
    }
    return false;
}
exports.contains = contains;
var ClassListProxy = /** @class */ (function () {
    function ClassListProxy(_wrappers) {
        this._wrappers = _wrappers;
    }
    Object.defineProperty(ClassListProxy.prototype, "length", {
        get: function () {
            if (this._wrappers.length > 0) {
                return this._wrappers[0].classList.length;
            }
            else {
                return 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    ClassListProxy.prototype.add = function (token) {
        this._wrappers.forEach(function (e) {
            e.classList.add(token);
        });
    };
    ClassListProxy.prototype.contains = function (token) {
        if (this._wrappers.length > 0) {
            return this._wrappers[0].classList.contains(token);
        }
        else {
            return false;
        }
    };
    ClassListProxy.prototype.item = function (i) {
        if (this._wrappers.length > 0) {
            return this._wrappers[0].classList.item(i);
        }
        else {
            return null;
        }
    };
    ClassListProxy.prototype.remove = function (token) {
        this._wrappers.forEach(function (e) {
            e.classList.remove(token);
        });
    };
    ClassListProxy.prototype.toggle = function (token, force) {
        var result = true;
        this._wrappers.forEach(function (e) {
            result = e.classList.toggle(token) && result;
        });
        return result;
    };
    return ClassListProxy;
}());
/**
 * Class which represents renderable text selection in DOM.
 */
var TextSelection = /** @class */ (function () {
    /**
     * Construct new text selection base on some element and offset and length
     * @param element root selection element
     * @param startOffset Offset in text (not elements) from beginning of provided element to beginning of selection
     * @param endOffset Offset in text (not elements)  from beginning of provided element to end of selection
     */
    function TextSelection(element, startOffset, endOffset) {
        this._ignoreTagList = exports.IGNORE_TAGS;
        this._wrappers = [];
        this._element = element;
        this._offset = startOffset;
        this._length = endOffset - startOffset;
    }
    Object.defineProperty(TextSelection.prototype, "text", {
        /**
         * Selection text string.
         */
        get: function () {
            if (!this._text) {
                this._text = this.readSelectionText();
            }
            return this._text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextSelection.prototype, "isRendered", {
        /**
         * Is selection rendered in dom.
         */
        get: function () {
            return this._isRendered;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextSelection.prototype, "element", {
        /**
         * Element where the selection is, can be a parent or parent of parent or ...
         */
        get: function () {
            return this._element;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextSelection.prototype, "offset", {
        /**
         * Offset in text (not elements)
         */
        get: function () {
            return this._offset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextSelection.prototype, "length", {
        /**
         * Length of selection in text (not elements)
         */
        get: function () {
            return this._length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextSelection.prototype, "classList", {
        /**
         * Class list for css classes manipulation on all rendered wrappers.
         */
        get: function () {
            return this._classList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextSelection.prototype, "wrappers", {
        /**
         * Array of content wrappers which represents the text selection.
         */
        get: function () {
            return this._wrappers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextSelection.prototype, "ignoreTagList", {
        /**
         * Array of tags which will be ignored by selection
         * @returns {Array<string>}
         */
        get: function () {
            return this._ignoreTagList;
        },
        set: function (ignoreTagList) {
            this._ignoreTagList = ignoreTagList;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Renders span wrappers in dom for selection.
     */
    TextSelection.prototype.render = function () {
        var _this = this;
        if (this.isRendered) {
            throw 'Selection already rendered';
        }
        this._isRendered = true;
        this._text = '';
        var wrapActions = [];
        // walk and collect info about wrappers
        // we cant modify dom during walking
        // so we are collecting info and later modify dom
        this.walkOverElement(function (actionType, node, text, startOffset, endOffset) {
            wrapActions.push({ type: actionType, node: node, startOffset: startOffset, endOffset: endOffset });
        });
        // render wrappers
        wrapActions.forEach(function (wa) {
            switch (wa.type) {
                case NodeActionType.TO:
                    _this.wrapTo(wa.node, wa.endOffset);
                    break;
                case NodeActionType.FROM:
                    _this.wrapFrom(wa.node, wa.startOffset);
                    break;
                case NodeActionType.BETWEEN:
                    _this.wrapBetween(wa.node, wa.startOffset, wa.endOffset);
                    break;
                case NodeActionType.WHOLE:
                    _this.wrap(wa.node);
                    break;
            }
        });
        this._classList = new ClassListProxy(this._wrappers);
    };
    /**
     * Remove span wrappers from dom.
     */
    TextSelection.prototype.clear = function () {
        this._wrappers.forEach(this.unwrap.bind(this));
        this._wrappers = [];
        this._isRendered = false;
        atomTags = [];
    };
    // batch operations on
    /**
     * Adds a new attribute or changes the value of an existing attribute on the specified element.
     * @param name is the name of the attribute as a string.
     * @param value is the desired new value of the attribute.
     */
    TextSelection.prototype.setAttribute = function (name, value) {
        this._wrappers.forEach(function (e) {
            e.setAttribute(name, value);
        });
    };
    /**
     * Returns the value of a specified attribute on the element. If the given attribute does not exist, the value returned will
     * either be null or '' (the empty string);
     * @param attributeName is the name of the attribute whose value you want to get.
     * @return string containing the value of attributeName.
     */
    TextSelection.prototype.getAttribute = function (attributeName) {
        if (this._wrappers.length > 0) {
            return this._wrappers[0].getAttribute(attributeName);
        }
        else {
            return null;
        }
    };
    /**
     * Removes an attribute from the specified element.
     * @param attrName is a string that names the attribute to be removed from element.
     */
    TextSelection.prototype.removeAttribute = function (attrName) {
        this._wrappers.forEach(function (e) {
            e.removeAttribute(attrName);
        });
    };
    /**
     * Method registers the specified listener on each rendered selection wrapper.
     * @param type A string representing the event type to listen for.
     * @param listener The object that receives a notification (an object that implements the Event interface) when an event of the
     *      specified type occurs. This must be an object implementing the EventListener interface, or simply a JavaScript function.
     * @param useCapture A Boolean that indicates that events of this type will be dispatched to the registered listener before
     *      being dispatched to any EventTarget beneath it in the DOM tree.
     */
    TextSelection.prototype.addEventListener = function (type, listener, useCapture) {
        this._wrappers.forEach(function (e) {
            e.addEventListener(type, listener, useCapture);
        });
    };
    /**
     * Method removes the event listener previously registered with .addEventListener().
     * @param type A string representing the event type to listen for.
     * @param listener The object that receives a notification (an object that implements the Event interface) when an event of the
     *      specified type occurs. This must be an object implementing the EventListener interface, or simply a JavaScript function.
     * @param useCapture A Boolean that indicates that events of this type will be dispatched to the registered listener before
     *      being dispatched to any EventTarget beneath it in the DOM tree.
     */
    TextSelection.prototype.removeEventListener = function (type, listener, useCapture) {
        this._wrappers.forEach(function (e) {
            e.removeEventListener(type, listener, useCapture);
        });
    };
    /**
     * Dispatches an Event at the all rendered wrappers, invoking the affected EventListeners in the appropriate order. The normal
     * event processing rules (including the capturing and optional bubbling phase) apply to events dispatched manually with dispatchEvent()
     * @param evt is the Event object to be dispatched.
     * @return The return value is false if at least one of the event handlers which handled this event called Event.preventDefault().
     *      Otherwise it returns true.
     */
    TextSelection.prototype.dispatchEvent = function (evt) {
        var result = true;
        this._wrappers.forEach(function (e) {
            result = (e.dispatchEvent(evt) !== false) && result;
        });
        return result;
    };
    /**
     * Adds a tag in ignore_tags list
     * @param tag
     */
    TextSelection.prototype.addIgnoredTag = function (tag) {
        this._ignoreTagList.push(tag);
    };
    /**
     * Removes a tag from ignore_tags list
     * @param tag
     */
    TextSelection.prototype.removeIgnoredTag = function (tag) {
        var index = this._ignoreTagList.indexOf(tag);
        if (index > -1) {
            this._ignoreTagList.splice(index, 1);
        }
    };
    TextSelection.prototype.readSelectionText = function () {
        var textValue = '';
        // walk and collect texts
        this.walkOverElement(function (actionType, node, text, startOffset, endOffset) {
            switch (actionType) {
                case NodeActionType.TO:
                    textValue += text.substring(0, endOffset);
                    break;
                case NodeActionType.FROM:
                    textValue += text.substring(startOffset);
                    break;
                case NodeActionType.BETWEEN:
                    textValue += text.substring(startOffset, endOffset);
                    break;
                case NodeActionType.WHOLE:
                    textValue += text;
                    break;
            }
        });
        return textValue;
    };
    TextSelection.prototype.walkOverElement = function (action) {
        var _this = this;
        var startOffset = this._offset;
        var endOffset = this._offset + this._length;
        var startNode;
        var endNode;
        domTraverse_1.walkOverTree(this._element, function (node) {
            // for each text node which has parent
            if (isTextSelectionChunk(node, _this._ignoreTagList)) {
                var text = node.nodeValue;
                var textLength = text.length;
                // if start is not found let check is current node a start node
                if (!startNode) {
                    // if not lets sub the length from offset
                    if (textLength <= startOffset) {
                        startOffset = startOffset - textLength;
                    }
                    else {
                        startNode = node;
                    }
                }
                // if node is endNode not lets sub the length from offset
                if (textLength <= endOffset) {
                    endOffset = endOffset - textLength;
                }
                else {
                    endNode = node;
                }
                // if we found the start and node isn't empty lets wrap content
                if (startNode && node.nodeValue.trim()) {
                    if (endNode) {
                        if (startNode === endNode) {
                            // if star and end of selection are is on same current node
                            action(NodeActionType.BETWEEN, node, text, startOffset, endOffset);
                        }
                        else {
                            // if the end of selection is on current node
                            action(NodeActionType.TO, node, text, startOffset, endOffset);
                        }
                        // we finished so we can break walk
                        return false;
                    }
                    else {
                        if (node === startNode) {
                            // if the start of selection is on current node
                            action(NodeActionType.FROM, node, text, startOffset, endOffset);
                        }
                        else {
                            // if selection weare startet but not yet ended
                            action(NodeActionType.WHOLE, node, text, startOffset, endOffset);
                        }
                    }
                }
            }
            // in general we will continue walk
            return true;
        });
    };
    TextSelection.prototype.nextWrapper = function (text) {
        this._text = this._text + text;
        var wrapper = document.createElement('span');
        wrapper.appendChild(document.createTextNode(text));
        this._wrappers.push(wrapper);
        return wrapper;
    };
    TextSelection.prototype.wrap = function (textNode) {
        var text = textNode.nodeValue;
        var wrapper = this.nextWrapper(text);
        domMutations_1.insertBefore(wrapper, textNode);
        textNode.parentNode.removeChild(textNode);
        return wrapper;
    };
    TextSelection.prototype.wrapTo = function (textNode, offset) {
        var text = textNode.nodeValue;
        var wrapper = this.nextWrapper(text.substring(0, offset));
        textNode.nodeValue = text.substring(offset);
        domMutations_1.insertBefore(wrapper, textNode);
        return wrapper;
    };
    TextSelection.prototype.wrapFrom = function (textNode, offset) {
        var text = textNode.nodeValue;
        var wrapper = this.nextWrapper(text.substring(offset));
        textNode.nodeValue = textNode.nodeValue.substring(0, offset);
        domMutations_1.insertAfter(wrapper, textNode);
        return wrapper;
    };
    TextSelection.prototype.wrapBetween = function (textNode, startOffset, endOffset) {
        var text = textNode.nodeValue;
        var wrapper = this.nextWrapper(text.substring(startOffset, endOffset));
        textNode.nodeValue = text.substring(0, startOffset);
        domMutations_1.insertAfter(document.createTextNode(text.substring(endOffset)), textNode);
        domMutations_1.insertAfter(wrapper, textNode);
        return wrapper;
    };
    TextSelection.prototype.unwrap = function (node) {
        var parent = node.parentNode;
        while (node.firstChild) {
            domMutations_1.insertBefore(node.firstChild, node);
        }
        parent.removeChild(node);
        this.concatSiblingTextNodes(parent);
    };
    TextSelection.prototype.concatSiblingTextNodes = function (parent) {
        var childs = parent.childNodes;
        var firstSibling = this.siblingTextNode(childs);
        while (firstSibling) {
            firstSibling.nodeValue += firstSibling.nextSibling.nodeValue;
            parent.removeChild(firstSibling.nextSibling);
            firstSibling = this.siblingTextNode(childs);
        }
    };
    /**
     * Utils method looks for siblingTextNodes
     * @param childs: target list of nodes.
     * @returns first of two sibling textNodes. Otherwise it returns null.
     */
    TextSelection.prototype.siblingTextNode = function (childs) {
        for (var i = 0; i < childs.length - 1; i++) {
            if (childs[i].nodeType === NODE_TYPE.TEXT_NODE &&
                childs[i + 1].nodeType === NODE_TYPE.TEXT_NODE) {
                return childs[i];
            }
        }
        return null;
    };
    return TextSelection;
}());
exports.TextSelection = TextSelection;
/**
 * Check is provided selection within particular element
 * @param selection selection to check
 * @param element element within the selection should be defined
 */
function isSelectionWithin(selection, element) {
    if (selection.rangeCount > 0) {
        var range = selection.getRangeAt(0);
        return domTraverse_1.isChildOf(range.startContainer, element) && domTraverse_1.isChildOf(range.endContainer, element);
    }
    else {
        return false;
    }
}
exports.isSelectionWithin = isSelectionWithin;
function getSelectionOffsets(selection, element, ignoreTags) {
    var tags = ignoreTags || exports.IGNORE_TAGS;
    var startOffset = 0;
    var endOffset = 0;
    var range = selection.getRangeAt(0);
    var startNode = range.startContainer;
    var endNode = range.endContainer;
    var startFound = false;
    var startNodeInited = isTextSelectionChunk(startNode, tags);
    var startNodeSearchStarted = false;
    var isNewEndNode = false;
    // in some cases endNode isn't a textNode, so we should look for previous textNode in DFS direction
    if (!isTextSelectionChunk(endNode, tags)) {
        var lastNode = domTraverse_1.findLastNode(endNode);
        if (isTextSelectionChunk(lastNode, tags)) {
            endNode = lastNode;
        }
        else {
            domTraverse_1.reverseWalkOverTree(endNode, element, function (node) {
                if (isTextSelectionChunk(node, tags)) {
                    endNode = node;
                    isNewEndNode = true;
                    return false;
                }
                return true;
            });
        }
    }
    domTraverse_1.walkOverTree(element, function (node) {
        // in some cases startNode isn't a textNode, so we should look for next textNode in DFS direction
        // if startNode isn't textNode
        if (!startNodeInited) {
            // and if searching of startNode isn't started
            if (!startNodeSearchStarted) {
                // try to start
                startNodeSearchStarted = node === startNode;
            }
            else if (isTextSelectionChunk(node, tags)) {
                // startNode now is text node, so we can continue walking without problems
                startNode = node;
                startNodeInited = true;
            }
        }
        // for each text node which has parent
        if (isTextSelectionChunk(node, tags)) {
            if (node === startNode) {
                startFound = true;
                startOffset += range.startOffset;
                if (node === endNode) {
                    // endNode was chosen by reverseWalk, so we should take full nodeValue
                    if (isNewEndNode) {
                        endOffset += node.nodeValue.length;
                    }
                    else {
                        endOffset += range.endOffset;
                    }
                    return false;
                }
                else {
                    endOffset += node.nodeValue.length;
                }
            }
            else if (node === endNode) {
                endOffset += range.endOffset;
                return false;
            }
            else {
                endOffset += node.nodeValue.length;
                if (!startFound) {
                    startOffset += node.nodeValue.length;
                }
            }
        }
        return true;
    });
    atomTags = [];
    return { startOffset: startOffset, endOffset: endOffset };
}
exports.getSelectionOffsets = getSelectionOffsets;
// This is not used in this implementation
// please do not remove, may be useful during integration with GA
// /**
//  * whitespaces skipping
//  * space - 32
//  * tab - 9
//  * carriage return - 13
//  * line feed - 10
//  * form feed - 12
//  * zero width space - 8203
//  * non-breaking space - 160
//  */
// let CHARS_TO_SKIP: Array<number> = [32, 9, 13, 10, 12, 8203, 160];
//
//
// /**
//  * Counting the chars
//  * @expose
//  * @public
//  * @param {string} text
//  * @returns {number}
//  */
// function textLength(text: string) {
//     let count = 0;
//     for (let i = 0; i < text.length; i++) {
//         if (CHARS_TO_SKIP.indexOf(text.charCodeAt(i)) == -1) {
//             count++;
//         }
//     }
//     return count;
// }
